import { useEffect } from "react"

import { useUI } from "providers/UIProvider"

import { Container, Center, Box } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import Icon from "components/UI/atoms/Icon"
import Button from "components/UI/atoms/Button"
import Input from "components/UI/atoms/Input"
import useDistricts from "hooks/useDistricts"
import { useDistrictsContext } from "providers/DistrictsProvider/DistrictsProvider"


const AddEditDistrictModal = () => {

  const { modals, toggleModal, T } = useUI()

  const editMode = modals.addEditDistrictModal.data ? true : false

  const { addDistrictLoading, updateDistrictLoading } = useDistrictsContext()
  const { form: { values, errors, touched, handleBlur, handleChange, resetForm, handleSubmit } } = useDistricts(modals.addEditDistrictModal.data)
  
  const handleClose = () => {
    toggleModal("addEditDistrictModal", false)
  }

  useEffect(()=>{
    if(!editMode) {
      resetForm()
    }
  },[modals.addEditDistrictModal.isOpened])
 
  return (
    <Modal
      isOpen={modals.addEditDistrictModal.isOpened}
      onClose={handleClose}
      // keyword - add_district.title || edit_district.title
      title={editMode ? T("add_district.title") : T("edit_district.title")}
      styles={{
        width: "566px",
        headerPadding: "20px 15px",
        bodyPadding: "20px 30px"
      }}
    >
      <Container padding={0}>
        <Box>
              <Input
                  id="cancellation-fee-time2"
                  styles={{
                      width: "100%",
                      height: "50px",
                  }}
                  type="text"
                  label={T("district.form.name")}
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(errors.name && touched.name)}
                  errorMessage={errors.name}
              />
        </Box>
        <Center mt="45px">
          <Button
            text={T("actions.add")}
            onClick={handleSubmit}
            leftIcon={ <Icon name="confirm" iconStyles={{ width: "34px", height: "34px" }} /> }
            styles={{ width: "180px", height: "63px", fontSize: "xl" }}
            isDisabled={addDistrictLoading || updateDistrictLoading}
            isLoading={addDistrictLoading || updateDistrictLoading}
            type="submit"
          />
        </Center>
      </Container>
    </Modal>
  )
}

export default AddEditDistrictModal